import { lazy } from 'react';

export const AttributesDifficultyLevelsPage = lazy(
  () => import('./AttributesDifficultyLevelsPage'),
);
